var map = {
	"./account-access.svg": 751,
	"./change-password.svg": 752,
	"./change-user-info.svg": 753,
	"./checkmark-circle.svg": 754,
	"./digital-print.svg": 755,
	"./dropzone.svg": 756,
	"./large-print.svg": 757,
	"./lorry.svg": 758,
	"./photo-products.svg": 759,
	"./print-demand.svg": 760,
	"./settings.svg": 761,
	"./stars.svg": 762,
	"./upload.svg": 763
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 750;